import React, { FC } from 'react';

import { useReduxPersistLocalStorage } from '@/global/hooks/useReduxPersistLocalStorage';
import { persistPagesReducerObj } from '@/store/redux';
import { updateCheckoutDeliveryState } from '@/store/redux/slices/pages/checkout/delivery';
import { handleUpdateFavoriteState } from '@/store/redux/slices/pages/favorites';
import { handleUpdateServiceBooking } from '@/store/redux/slices/pages/serviceBooking';

const StatePersistProvider: FC<React.PropsWithChildren<any>> = ({
  children,
}) => {
  const { favorites, checkoutDelivery, serviceBooking } =
    persistPagesReducerObj;

  // Reducers that needs to persist
  useReduxPersistLocalStorage(favorites, handleUpdateFavoriteState);
  useReduxPersistLocalStorage(checkoutDelivery, updateCheckoutDeliveryState);
  useReduxPersistLocalStorage(serviceBooking, handleUpdateServiceBooking);

  return <>{children}</>;
};

export default StatePersistProvider;
